import React from "react";
import { ReactComponent as Filter } from "../../assets/components-icons/filter.svg";
import { ReactComponent as HotDeal } from "../../assets/components-icons/forest-fire.svg";
import Filtering from "./Filters";
import { MobileFiltersWrapper } from "../Layout/MobileFiltersWrapper";
import { Button } from '../Layout/Elements';
import { UserContext } from '../../context/user'

const MobileFilters = ({handleBest, handleClick,click}) => {
  const {height} = React.useContext(UserContext)
  

  return (
    <section className="wrapper-sec">
      
      <div className={ height > 2658 ? 'svg-div' : 'svg-div svg-div-show'}>
      <div className='svg-container'>
        <Filter className='svgAll'  onClick={handleClick} />
        <div className='border-between'></div>
        <HotDeal className='svgAll' onClick={handleBest} />
      </div>
      </div>


      <MobileFiltersWrapper visible={click}>
        <div className="d-flex control-div  flex-column">
          <div>
            <div>
              <Filtering />
            </div>
          </div>
          <div className="mt-5 mb-3">
            <Button 
            width='100%'
            radius='40px'
            padding='10px'
            bg='var(--navbar-bg)'
            color='white'
            fontWeight='bold'
            fontSize='16px'
            onClick={handleClick}>
              Apply filters
            </Button>
          </div>
        </div>
      </MobileFiltersWrapper>
    </section>
  );
};

export { MobileFilters as default };
